import { useState } from "react";
import { useHistory } from "react-router-dom";
import useAxios from "../../hooks/useAxios";
import { message } from "antd";
import { ReactLoading } from "../Dashboard/TinManagement/import";

const PhoneNumberInput = () => {
    
  const api = useAxios();
  const [phoneNumber, setPhoneNumber] = useState("");
  const [loading, setLoading] = useState("");
  const [error, setError] = useState("");
  const history = useHistory();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!/^\d{10}$/.test(phoneNumber)) {
      setError("Please enter a valid 10-digit phone number");
      return;
    }
    setError("");
    try {
      setLoading(true);
      const { data } = await api.post(
        `/languageConfidence/checkMobileNoExist`,
        {
          formId: "61d41ac7cc03506243d626f9",
          mobileNo: phoneNumber,
        }
      );
      const { status } = data || {};
      if (status) {
        return history.push(`/language-confidence/test/${phoneNumber}`);
      }

    } catch (err) {
      console.error(err);
      message.error(err?.response?.data?.error?.message || `Something went wrong.`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && (
        <ReactLoading type="spin" color="#0000FF" className="spinnerBg" />
      )}
      <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
        <div className="w-full max-w-md bg-white rounded-lg shadow-md p-6">
          <div className="flex justify-center mb-2 pr-2">
            <img
              src="/Maxicus_logo.png"
              alt="Maxicus Logo"
              className="h-16 w-auto object-contain"
            />
          </div>
          <h2 className="text-2xl font-bold mb-6 text-center text-gray-800">
            Enter Your Phone Number
          </h2>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label
                htmlFor="phone"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Phone Number
              </label>
              <input
                type="tel"
                id="phone"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
                placeholder="Enter 10-digit number"
                className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                maxLength={10}
                pattern="\d{10}"
                required
              />
              {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
            </div>
            <button
              type="submit"
              className="w-full bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
            >
              Submit
            </button>
          </form>

          <div className="mt-6 bg-blue-50 p-4 rounded-lg">
            <h3 className="text-lg font-semibold text-blue-800 mb-2">
              Assessment Information
            </h3>
            <div className="space-y-3 text-sm text-gray-700">
              <p>
                This assessment consists of{" "}
                <span className="font-medium">20 questions</span> to evaluate
                your speaking skills.
              </p>

              <div className="mt-3">
                <p className="font-medium mb-1">How to attempt:</p>
                <ol className="list-decimal list-inside space-y-1">
                  <li>
                    Click the <span className="font-medium">Play Question</span>{" "}
                    button to listen to each question
                  </li>
                  <li>
                    Record your response by clicking the{" "}
                    <span className="font-medium">Start Recording</span> button
                  </li>
                  <li>You'll have up to 1 minute to record each response</li>
                  <li>You can listen to your recording before submitting</li>
                  <li>
                    Navigate between questions using the Previous/Next buttons
                  </li>
                </ol>
              </div>

              <div className="mt-3 p-3 bg-blue-100 rounded border border-blue-200">
                <p className="font-medium text-blue-800 flex items-start">
                  <svg
                    className="w-5 h-5 mr-2 mt-0.5 flex-shrink-0"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fillRule="evenodd"
                      d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h2a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                      clipRule="evenodd"
                    />
                  </svg>
                  Tips for best results:
                </p>
                <ul className="list-disc list-inside mt-1 space-y-1">
                  <li>Find a quiet environment</li>
                  <li>Speak clearly and at a natural pace</li>
                  <li>Answer each question as completely as possible</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PhoneNumberInput;
